import { CitiesPage } from 'src/cities';
import { MainLayout } from 'components/layouts/main-layout';

export default Object.assign(CitiesPage, { layout: MainLayout });
